export type NewsListProps = {
	tags: string[];
	contentId: string;
	openLinkInNewTab: boolean;
	tagSelectorBackgroundColour?: string;
	selectedTagHighlightColour?: string;
	rSSFeedUrl?: string;
	displayMode?: string;
	hideThumbnail?: boolean;
	filterAlignment?: 'Left' | 'Right' | 'Center (default)';
	showFullReadMore?: boolean;
	numberOfReadMoreLines?: number;
	searchBarOption?: 'Show full search and filter bar (default)' | 'Show only search box' | 'Do not show search or filters' | undefined;
	readMoreTextColour?: string;
	disablePagination?: boolean;
	enableRatings?: boolean;
	authors?: string[];
};

export enum NewsListSortType {
	DateNewestFirst = 0,
	DateOldestFirst = 1,
	RatingHighestFirst = 2,
	RatingLowestFirst = 3
}

export type GetNewsByTagsInputModel = {
	contentId: string;
	tags: string[];
	page: number;
	pageSize: number;
	rSSFeedUrl?: string;
	search?: string;
	to?: Date;
	from?: Date;
	sortBy?: NewsListSortType;
	showFullReadMore?: boolean;
	disablePagination?: boolean;
	minRating?: number;
	authors?: string[];
};

export type NewsListItemModel = {
	truncatedTitle: string;
	title: string;
	author: string;
	thumbnailUrl?: string;
	mobileThumbnailUrl?: string;
	summary: string;
	body: string;
	showReadMore: boolean;
	readMore: string;
	publishDate: Date;
	publishDateFormatted: string;
	link: string;
	caption: string;
	isOpenInNewTab: boolean;
	redirect: string;
	originalImageUrl: string;
	useOriginalImageUrl: boolean;
	readMoreSummary: string;
	tags: string[];
	averageRating?: number;
	ratingCount: number;
	authorPageUrls?: AuthorPageLink[];
};

export type AuthorPageLink = {
	author: string;
	pageId: number;
	pageUrl: string;
};

export type GetNewsByTagsResultModel = {
	totalPages: number;
	newsItems: NewsListItemModel[];
};
